<div class="container-fluid">
    <div class="row">
        <div class="col col-sm-12 px-0" [ngClass]="status ? 'collapsed' : 'expanded'">
            <div class="sidemenu shadow-sm">

                <div class="sidemenu-brand d-flex flex-row p-3 align-items-center">
                    <img src="/assets/img/logo.png" style="height:32px; width:auto"/>
                    <p class="ms-3 mb-0 mt-0 p-0 fw-bold">Inote</p>
                </div>

                <div class="panelmenu-wrap">
                    <p-panelMenu [model]="items" [multiple]="false"></p-panelMenu>
                </div>

                <div class="collapsedmenu-wrap">
                    <div class="collapsedmenu-inner d-flex align-items-center justify-content-center flex-column">
                        <button type="button" pButton (click)="menu.toggle($event)" class="d-md-none p-button-text p-button-img d-flex align-items-center justify-content-center">
                            <img src="/assets/img/company.png"style="height:18px; width:auto"/>
                        </button>
                        <button type="button" pButton icon="pi pi-book" (click)="menu.toggle($event)" class="p-button-text"></button>
                        <button type="button" pButton icon="pi pi-th-large" (click)="menu.toggle($event)" class="p-button-text"></button>
                        <button type="button" pButton icon="pi pi-id-card" (click)="menu.toggle($event)" class="p-button-text"></button>
                        <button type="button" pButton icon="pi pi-dollar" (click)="menu.toggle($event)" class="p-button-text"></button>
                        <button type="button" pButton icon="pi pi-file" (click)="menu.toggle($event)" class="p-button-text"></button>
                        <button type="button" pButton icon="pi pi-cog" (click)="menu.toggle($event)" class="p-button-text"></button>
                    </div>
                    <p-menu #menu [popup]="true" [model]="popmenuItems"></p-menu>
                </div>
                
            </div>
            <div class="maincontent">
                <div class="position-relative">
                    <div class="topnav d-flex justify-content-end justify-content-md-between align-items-center px-3 border-bottom position-fixed" style="height:65px; top:0px; z-index:5;">
                        <a (click)="clickEvent()" class="expandControl d-none d-md-block">
                        </a>
                        <div class="d-flex flex-row align-items-center profileMenu">
                            <a class="companySwitch p-text-secondary d-none d-md-block">
                                <div class="companySwitchInner d-flex flex-row align-items-center">
                                    <img src="/assets/img/company-dark.png" style="height: 18px; width: auto;" class="me-2"/>
                                    <span class="me-2">Hayleys Lanka (PVT) LTD</span> 
                                    <i class="pi pi-chevron-down" style="font-size: 12px; font-weight: bold;"></i>
                                </div>
                            </a>
                            <button pButton pRipple type="button" class="p-button-text mx-4 p-text-secondary" icon="pi pi-bell" ></button>
                            <a class="profileavatar" (click)="profile.toggle($event)">
                                AB
                            </a>
                            <p-menu #profile  [popup]="true" [model]="profileMenu"></p-menu>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-sm-12 px-0" style="padding-top: 65px;">
                    <router-outlet></router-outlet>
                </div>
            </div>
        </div>
    </div>
</div>





